import { axios } from "@/plugins/http-request.js";

const state = {
  linehaulConfig: {},
  paperFormats: [],
  labelTypes: [],
  barcodeTypes: [],
};

const getters = {
  linehaulConfig: (state) => state.linehaulConfig,
  paperFormats: (state) => state.paperFormats,
  labelTypes: (state) => state.labelTypes,
  barcodeTypes: (state) => state.barcodeTypes,
};

const actions = {
  getLinehaulList(context, payload) {
    return axios
      .get("/api/linehaul/list", {
        params: payload,
      })
      .then((res) => res.data);
  },
  getLinehaulUIData(context, payload) {
    return axios
      .get("/api/linehaul/ui-data/" + payload.id, {
        params: payload.params,
      })
      .then((res) => res.data);
  },
  editLinehaul(context, id) {
    return axios
      .post("/api/linehaul/carrier-list-edit", id)
      .then((res) => res.data);
  },

  updateLinehaulUIData(context, payload) {
    return axios.post("/api/linehaul/post", payload).then((res) => res.data);
  },
  deleteLinehaulUIData(context, id) {
    return axios.delete("/api/linehaul/delete/" + id).then((res) => res.data);
  },
  getLinehaulConfig(context, id) {
    if (Object.keys(context.getters.linehaulConfig).length) return;
    return axios
      .get(`/api/linehaul/configuration?client_id=${id}`)
      .then((res) => {
        context.commit("setLineHaulConfig", res.data.data);
        return res.data;
      });
  },
  getLinehaulConfigAddId(context, id) {
    return axios
      .get(`/api/linehaul/configuration?client_id=${id}`)
      .then((res) => {
        context.commit("setLineHaulConfig", res.data.data);
        return res.data;
      });
  },

  updateLinehaulStatus(context, payload) {
    return axios
      .patch("/api/linehaul/inactive/" + payload.id, {
        params: payload.data,
      })
      .then((res) => res.data);
  },
  linehaulcities(_, id) {
    return axios.get(`/api/${id}/cities`).then((res) => res.data);
  },

  linehaulareas(_, payload) {
    return axios
      .get(`/api/${payload.id}/areas`, {
        params: payload.params,
      })
      .then((res) => res.data);
  },
  linehaulpincode(_, id) {
    return axios.get(`/api/pincode-list/${id}`).then((res) => res.data);
  },
  linehaulCityList(_, payload) {
    return axios
      .get(
        `/api/linehaul/coverage_list?linehaul_id=${payload.id}&type=${payload.type}`
      )
      .then((res) => res.data);
  },
  getCarrierRestrictions(context, payload) {
    return axios
      .get(
        `/api/linehaul/${payload.linehaul_id}/restriction/${payload.carrier_id}`,
        {
          params: payload.params,
        }
      )
      .then((res) => res.data);
  },
  saveCarrierRestrictions(context, payload) {
    return axios
      .post(
        `/api/linehaul/${payload.linehaul_id}/restriction/${payload.carrier_id}`,
        payload.body
      )
      .then((res) => res.data);
  },
  getCities(context, payload) {
    return axios
      .get(`/api/${payload.countryCode}/cities`, {
        params: payload.params,
      })
      .then((res) => res.data);
  },
  getPaperFormats(context) {
    if (context.getters.paperFormats.length) return;
    return axios.get(`/api/paper-format/list`).then((res) => {
      context.commit("setPaperFormats", res.data.data);
      return res.data;
    });
  },
  getLabelTypes(context) {
    if (context.getters.labelTypes.length) return;
    return axios.get(`/api/label-type/list`).then((res) => {
      context.commit("setLabelTypes", res.data.data);
      return res.data;
    });
  },
  getBarcodeTypes(context) {
    if (context.getters.barcodeTypes.length) return;
    return axios.get(`/api/barcode/types`).then((res) => {
      context.commit("setBarcodeTypes", res.data.data);
      return res.data;
    });
  },
  getAllCity(context, payload) {
    if (payload.id !== undefined) {
      return axios
        .get(`/api/client-linehauls/list?client_id=${payload.id}`, {
          params: payload,
        })
        .then((res) => res.data);
    } else {
      return axios
        .get(`/api/client-linehauls/list`, {
          params: payload,
        })
        .then((res) => res.data);
    }
  },
  downloadCity(context, payload) {
    if (payload.client_id !== undefined) {
      return axios
        .get(
          `/api/client-coverages?linehaul_id=${payload.id}&client_id=${payload.client_id}`,
          {
            responseType: "blob",
          }
        )
        .then((res) => res);
    } else {
      return axios.get(`/api/client-coverages?linehaul_id=${payload.id}`, {
        responseType: "blob",
      });
    }
  },
  downloadPincode(context, payload) {
    if (payload.client_id !== undefined) {
      return axios
        .get(
          `/api/client-coverages-pincode?linehaul_id=${payload.id}&client_id=${payload.client_id}`,
          {
            responseType: "blob",
          }
        )
        .then((res) => res);
    } else {
      return axios.get(
        `/api/client-coverages-pincode?linehaul_id=${payload.id}`,
        {
          responseType: "blob",
        }
      );
    }
  },
  downloadArea(context, payload) {
    if (payload.client_id !== undefined) {
      return axios
        .get(
          `/api/client-coverages-area?linehaul_id=${payload.id}&client_id=${payload.client_id}`,
          {
            responseType: "blob",
          }
        )
        .then((res) => res);
    } else {
      return axios.get(`/api/client-coverages-area?linehaul_id=${payload.id}`, {
        responseType: "blob",
      });
    }
  },
  downloadAllCity(context, payload) {
    if (payload.client_id !== undefined) {
      return axios
        .get(`/api/client-coverages?client_id=${payload.client_id}`, {
          responseType: "blob",
        })
        .then((res) => res);
    } else {
      return axios.get(`/api/client-coverages`, {
        responseType: "blob",
      });
    }
  },
  downloadRSACity(context, payload) {
    if (payload.client_id !== undefined) {
      return axios
        .get(
          `/api/client-coverages/rsa_city_fulfillment?client_id=${payload.client_id}&flag=excel`,
          {
            responseType: "blob",
          }
        )
        .then((res) => res);
    } else {
      return axios.get(`/api/client-coverages`, {
        responseType: "blob",
      });
    }
  },
  getLinehaulConfiguration(_, id) {
    return axios
      .get(`/api/linehaul/configuration?client_id=${id}`)
      .then((res) => res.data);
  },
  getLinehaulDelivery(_, data) {
    return axios
      .get(
        `/api/linehaul/configuration?client_id=${data.id}&delivery_type=${data.type}`
      )
      .then((res) => res.data);
  },
  getPudoConfiguration(_, id) {
    return axios
      .get(`/api/client-allocationrule/dropdown_list?client_id=${id}`)
      .then((res) => res.data);
  },
  searchPudoLocation(context, payload) {
    return axios
      .post("/api/client_pudo/search", payload)
      .then((res) => res.data);
  },
  // getTransitCountry(context, payload) {
  //   return axios
  //     .get(
  //       `/api/linehaul/carrier-list?client_id=${payload.client_id}&origin_country=${payload.from_country_code}&destination_country=${payload.to_country_code}&duty_handling=${payload.duty_handling}&delivery_type=${payload.delivery_type}`
  //     )
  //     .then((res) => res.data);
  // },
  getTransitCountry(context, payload) {
    return axios
      .post("/api/linehaul/carrier-list", payload)
      .then((res) => res.data);
  },
  linehaulCityDownload(context, payload) {
    return axios
      .post("/api/linehaul_coverage_download", payload, {
        responseType: "blob",
      })
      .then((res) => res);
  },
  getTransitCountryedit(context, payload) {
    return axios
      .get(`/api/linehaul/carrier-list?linehaul_id=${payload.linehaul_id}`)
      .then((res) => res.data);
  },
  addLInehaul(context, payload) {
    return axios.post("/api/linehaul/post", payload).then((res) => res.data);
  },
  updateLInehaul(context, payload) {
    return axios
      .post(`/api/linehaul/update/${payload.id}`, payload)
      .then((res) => res.data);
  },
};

const mutations = {
  setPaperFormats: (state, paperFormats) => {
    state.paperFormats = paperFormats;
  },
  setLabelTypes: (state, labelTypes) => {
    state.labelTypes = labelTypes;
  },
  setBarcodeTypes: (state, barcodeTypes) => {
    state.barcodeTypes = barcodeTypes;
  },
  setLineHaulConfig: (state, linehaulConfig) => {
    state.linehaulConfig = linehaulConfig;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
